<template>
    <div class="confirmOrderWrap">
        <!-- <nav-bar></nav-bar> -->
        <div class="top">
            <div class="topContent fr ac jsb">
                <div class="fc">
                    <h3>订单确认</h3>
                    <p>订单超时未支付将自动取消</p>
                </div>
                <span v-if="remainingTime < 3600"
                    >{{
                        Math.floor(remainingTime / 60)
                    }}:{{remainingTime % 60 &lt; 10 ? '0'+remainingTime % 60 : remainingTime % 60}}</span
                >
                <span v-else
                    >{{
                        Math.floor(remainingTime / 3600)
                    }}:{{Math.floor((remainingTime % 3600) / 60) &lt; 10 ? '0'+Math.floor((remainingTime % 3600) / 60) : Math.floor((remainingTime % 3600) / 60)}}:{{remainingTime % 60 &lt; 10 ? '0'+remainingTime % 60 : remainingTime % 60}}</span
                >
            </div>
        </div>
        <div class="contentWrap">
            <div v-show="orderInfo.ordertype == 'M'" class="movieInfo fr ac">
                <img class="poster" :src="posterUrl + '_180x180'" alt />
                <div class="movieDetail fc jsb">
                    <h3 class="fr afs jsb">
                        {{ movieInfo.影片 }}
                        <span>{{ ticketNum }}张</span>
                    </h3>
                    <span>{{ movieInfo.场次 }}({{ movieInfo.版本 }})</span>
                    <span>{{ movieInfo.影院 }}</span>
                    <span>{{ movieInfo.影厅 }}</span>
                    <span>{{ movieInfo.影票 }}</span>
                </div>
            </div>
            <div class="phoneBox fr ac jsb">
                <div class="fr ac">
                    <img
                        class="phoneIco"
                        src="../../../static/imgs/movie/phone_ico.png"
                        alt
                    />
                    <div class="txtWrap fc jsb">
                        <strong>{{ phoneNo }}</strong>
                        <span v-if="isKfc"
                            >购买成功后，会收到订单成功的相关短信</span
                        >
                        <span v-else>购票成功后，会收到取票码短信</span>
                    </div>
                </div>
                <!-- <img class="enterIco" src="../../../static/imgs/movie/enter.png" alt /> -->
            </div>
            <!-- 优惠券 隐藏 -->
            <div @click="toggleCoupon" class="couponBox fr ac jsb">
                <div class="fr ac">
                    <img
                        class="couponIco"
                        src="../../../static/imgs/movie/coupon.png"
                        alt=""
                    />
                    <span class="title">优惠券</span>
                </div>
                <div class="fr ac">
                    <span v-show="!couponList.length" class="txt"
                        >无可用优惠券</span
                    >
                    <span v-show="couponList.length" class="txt"
                        >{{ couponList.length }}张优惠券<strong class="tc"
                            >（已选{{ selectedCouponArr.length }}张）</strong
                        ></span
                    >
                    <img
                        class="enterIco"
                        src="../../../static/imgs/movie/enter.png"
                        alt
                    />
                </div>
            </div>
            <div v-show="orderInfo.ordertype == 'S'" class="products fc">
                <div
                    v-for="(item, index) in orderInfo.buyItemList"
                    :key="index"
                    class="basicInfo fr"
                >
                    <img :src="item.logo" alt />
                    <div class="info fc jsa">
                        <h3>{{ item.productName }}555</h3>
                        <span class="sku grey">{{ item.skuName }}</span>
                        <div class="fr ac jsb">
                            <span class="grey">
                                <strong class="price">{{ item.price }}</strong
                                >元
                            </span>
                            <span class="grey">×{{ item.qty }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div v-show="orderInfo.ordertype == 'M'" class="payMethod">
                <div class="row fr ac jsb">
                    <span>可用优惠</span>
                    <p @click="toggleCoupon" class="fr ac">
                        <span>
                            {{couponList.length}}张优惠券
                            <strong
                                v-show="selectedCouponArr.length"
                                class="tc"
                            >（已选{{selectedCouponArr.length}}张）</strong>
                        </span>
                        <img class="rightIco" src="../../../static/imgs/movie/rightArrow.png" alt />
                    </p>
                </div>
            </div> -->
            <div class="payMethod">
                <div @click="switchVipPay" class="row fr ac jsb">
                    <p class="method fr ac">
                        <img
                            class="methodIco"
                            src="../../../static/imgs/movie/vipCard.png"
                            alt
                        />
                        <span>贵宾卡支付</span>
                    </p>
                    <div class="balance fr ac">
                        <span
                            v-show="
                                orderInfo.vipcardbalance &&
                                !orderInfo.unUseBalanceDesc
                            "
                            class="balanceNum"
                            >余额：{{ orderInfo.vipcardbalance / 100 }}片</span
                        >
                        <div
                            class="balanceDesp fr ac"
                            v-show="
                                orderInfo.vipcardbalance != undefined &&
                                orderInfo.unUseBalanceDesc
                            "
                        >
                            <span class="txt">余额：</span>
                            <div class="fc afe">
                                <span class="orangeTxt">{{
                                    orderInfo.balanceDesc
                                        ? orderInfo.balanceDesc
                                        : ""
                                }}</span>
                                <span class="greyTxt">{{
                                    orderInfo.unUseBalanceDesc
                                        ? orderInfo.unUseBalanceDesc
                                        : ""
                                }}</span>
                            </div>
                        </div>
                        <span class="checkBox center">
                            <img
                                :src="
                                    isVipPay
                                        ? selectIco[1].path
                                        : selectIco[0].path
                                "
                                alt
                            />
                        </span>
                    </div>
                </div>
            </div>
            <div class="payMethod">
                <!-- <p class="title">选择支付方式</p> -->
                <!-- <div v-show="!isWeixin" @click="switchWechatPay" class="row fr ac jsb"> -->
                <div @click="switchWechatPay" class="row fr ac jsb">
                    <p class="method fr ac">
                        <img
                            class="methodIco"
                            src="../../../static/imgs/movie/wechat_pay.png"
                            alt
                        />
                        <span>微信</span>
                    </p>
                    <p class="balance fr ac">
                        <span class="checkBox center">
                            <img
                                :src="
                                    isWechatPay
                                        ? selectIco[1].path
                                        : selectIco[0].path
                                "
                                alt
                            />
                        </span>
                    </p>
                </div>
                <div @click="switchAliPay" class="row fr ac jsb">
                    <p class="method fr ac">
                        <img
                            class="methodIco"
                            src="../../../static/imgs/movie/ali_pay.png"
                            alt
                        />
                        <span>支付宝</span>
                    </p>
                    <p class="balance fr ac">
                        <span class="checkBox center">
                            <img
                                :src="
                                    isAliPay
                                        ? selectIco[1].path
                                        : selectIco[0].path
                                "
                                alt
                            />
                        </span>
                    </p>
                </div>
                <!-- 银联云闪付 -->
                <!-- <div @click="switchUnionPay" class="row fr ac jsb">
                    <p class="method fr ac">
                        <img class="methodIco" src="../../../static/imgs/movie/union_pay.png" alt />
                        <span>云闪付</span>
                    </p>
                    <p class="balance fr ac">
                        <span class="checkBox center">
                            <img :src="isUnionPay ? selectIco[1].path : selectIco[0].path" alt />
                        </span>
                    </p>
                </div> -->
            </div>
            <div v-show="orderInfo.ordertype == 'M'" class="notice fc ac">
                <h3>购票须知</h3>
                <p>
                    1.请确认场次和时间无误，购买成功后将不予退换
                    <br />2.由于设备故障等不可抗因素，存在少量场次锁座失败情况
                    <br />3.平均10-30分钟出票，超过30分钟未出票请联系客服
                    <br />4.出票成功后，将以短信通知提醒您，可到影院取票机取票
                </p>
            </div>
        </div>
        <div v-if="showPayStatus" class="pay_status_layer">
            <div class="status_dialog fc">
                <h3>请确认支付是否已完成</h3>
                <p class="done" @click="payDone">已完成支付</p>
                <p class="fail" @click="payFail">支付遇到问题，重新支付</p>
            </div>
        </div>
        <div class="btmBar fr ac jsb">
            <!-- <span>
                实付
                <strong class="tc">￥{{orderInfo.amount}}</strong>
            </span> -->
            <div class="fc jc">
                <p class="total fr ac">
                    <em>￥</em>{{ orderInfo.amount }}<span>推荐</span>
                </p>
                <!-- <p class="discount">原价<span>￥70</span>共优惠了10元</p> -->
            </div>
            <button @click="prePay">确认支付</button>
        </div>
        <transition name="couponLayer">
            <div v-show="showCoupons" class="couponLayer fc">
                <p>优惠券（{{ couponList.length }}张）</p>
                <div class="listWrap fc">
                    <div
                        @click="selectCoupon(index)"
                        v-for="(item, index) in couponList"
                        :key="item.cardno"
                        class="couponItem"
                    >
                        <div
                            v-show="item.is_selected"
                            class="selectedIco center"
                        >
                            <img
                                src="../../../static/imgs/movie/duigou_white.png"
                                alt
                            />
                        </div>
                        <div class="itemInfo fr ac jsb">
                            <div class="fc">
                                <span>{{ item.amount }}元优惠券</span>
                                <span class="grey"
                                    >有效日期至：{{ item.enddate }}</span
                                >
                            </div>
                            <span class="tc">已激活</span>
                        </div>
                    </div>
                </div>
                <button @click="useCoupon" class="bg_tc">使用</button>
            </div>
        </transition>
        <div v-show="showCoupons" @click="toggleCoupon" class="shade"></div>
        <div v-show="showPwdLayer" class="pwdLayer fc ac">
            <p>支付密码</p>
            <input v-model="payPwd" type="password" />
            <span @click="forgetPwd" class="forgetPwd tc">忘记密码</span>
            <button @click="verifyPwd" class="bg_tc white">确定</button>
        </div>
        <div v-show="showPwdLayer" @click="togglePwdLayer" class="shade"></div>
        <div v-show="showWechatLayer" class="wechatLayer">
            <img class="wechatCode" :src="wechatCodePath" alt />
            <!-- <img class="wechatCode" src="../../../static/imgs/movie/qrcode.jpg" alt=""> -->
            <span>请长按识别二维码</span>
            <img
                @click="toggleWechatLayer"
                src="../../../static/imgs/movie/close.png"
                alt
                class="closeIco"
            />
        </div>
        <div v-show="showWechatLayer" class="shade"></div>

        <form
            name="unionPayForm"
            class="formBox"
            method="POST"
            :action="formAction"
        >
            <input
                type="text"
                name="accessType"
                v-model="formData.accessType"
            />
            <input type="text" name="backUrl" v-model="formData.backUrl" />
            <input type="text" name="bizType" v-model="formData.bizType" />
            <input type="text" name="certId" v-model="formData.certId" />
            <input
                type="text"
                name="channelType"
                v-model="formData.channelType"
            />
            <input
                type="text"
                name="currencyCode"
                v-model="formData.currencyCode"
            />
            <input type="text" name="encoding" v-model="formData.encoding" />
            <input type="text" name="frontUrl" v-model="formData.frontUrl" />
            <input type="text" name="merId" v-model="formData.merId" />
            <input type="text" name="orderId" v-model="formData.orderId" />
            <input type="text" name="signature" v-model="formData.signature" />
            <input type="text" name="txnAmt" v-model="formData.txnAmt" />
            <input
                type="text"
                name="txnSubType"
                v-model="formData.txnSubType"
            />
            <input type="text" name="txnTime" v-model="formData.txnTime" />
            <input type="text" name="txnType" v-model="formData.txnType" />
            <input type="text" name="version" v-model="formData.version" />
            <input
                type="text"
                name="signMethod"
                v-model="formData.signMethod"
            />
        </form>
        <form
            name="aliPayForm"
            class="formBox"
            method="GET"
            :action="formAction"
        >
            <input type="text" name="app_id" v-model="formData.app_id" />
            <input
                type="text"
                name="biz_content"
                v-model="formData.biz_content"
            />
            <input type="text" name="charset" v-model="formData.charset" />
            <input type="text" name="format" v-model="formData.format" />
            <input type="text" name="method" v-model="formData.method" />
            <input
                type="text"
                name="notify_url"
                v-model="formData.notify_url"
            />
            <input
                type="text"
                name="out_trade_no"
                v-model="formData.out_trade_no"
            />
            <input
                type="text"
                name="product_code"
                v-model="formData.product_code"
            />
            <input
                type="text"
                name="return_url"
                v-model="formData.return_url"
            />
            <input type="text" name="sign" v-model="formData.sign" />
            <input type="text" name="sign_type" v-model="formData.sign_type" />
            <input type="text" name="subject" v-model="formData.subject" />
            <input
                type="text"
                name="time_expire"
                v-model="formData.time_expire"
            />
            <input type="text" name="timestamp" v-model="formData.timestamp" />
            <input
                type="text"
                name="total_amount"
                v-model="formData.total_amount"
            />
            <input type="text" name="version" v-model="formData.version" />
        </form>
    </div>
</template>

<script>
import navBar from "../../components/common/navBar.vue";
import { Toast, Indicator, MessageBox } from "mint-ui";
export default {
    data() {
        return {
            phoneNo: this.getLocal("phoneNo"),
            openid: this.getLocal("openid") ? this.getLocal("openid") : "",
            code: this.$route.query.code ? this.$route.query.code : "",
            selectIcoPath: require("../../../static/imgs/movie/duigou_orange.png"),
            tradeno: this.$route.query.tradeno,
            movieInfo: {},
            seatsTxt: this.$route.query.seatsTxt
                ? this.$route.query.seatsTxt
                : "",
            remainingTime: 0, //支付剩余时间
            interval: null,
            orderInfo: {},
            isWeixin: false, //是否是微信环境
            isWechatPay: false, //是否使用微信支付
            isVipPay: false, //是否使用贵宾卡支付
            isUnionPay: false, //是否使用银联支付
            isAliPay: false, //是否使用支付宝支付
            isSelectCoupon: false, //是否选择了优惠券
            couponList: [],
            selectedCouponArr: [],
            showCoupons: false,
            cardnos: "",
            showPwdLayer: false,
            payPwd: "",
            showWechatLayer: false,
            wechatCodePath: "",
            formAction: "",
            formData: {},
            posterUrl: this.$route.query.posterUrl,
            ticketNum: this.$route.query.ticketNum,
            selectIco: [
                {
                    path: require("../../../static/imgs/movie/select.png"),
                    name: "未选",
                },
                {
                    path: require("../../../static/imgs/movie/selected.png"),
                    name: "已选",
                },
            ],
            isKfc: this.$route.query.isKfc ? this.$route.query.isKfc : "",
            domainType: this.$global.domainType,
            showPayStatus: false,
            isZeroPay: false,
        };
    },
    components: {
        navBar,
    },
    created() {
        let ua = navigator.userAgent.toLowerCase();
        this.isWeixin = ua.indexOf("micromessenger") != -1 ? true : false;

        // this.getOrderInfo();
        // this.getCouponInfo();

        // this.$nextTick(() => {
        //     setTimeout(() => {
        //         if (
        //             this.orderInfo.vipcardbalance &&
        //             !this.isVipPay &&
        //             !this.cardnos
        //         ) {
        //             this.switchVipPay();
        //         }
        //     }, 100);
        // });
        Promise.all([this.getOrderInfo(), this.getCouponInfo()])
            .then((result) => {
                console.log(this.isVipPay, this.cardnos)
                if (
                    this.orderInfo.items &&
                    this.orderInfo.items.length > 1 &&
                    this.couponList.length
                ) {
                    for (let i of this.orderInfo.items) {
                        for (let j in this.couponList) {
                            if (
                                i.itemtype != "N" &&
                                i.cardno == this.couponList[j].cardno
                            ) {
                                this.$set(
                                    this.couponList[j],
                                    "is_selected",
                                    true
                                );
                            }
                        }
                    }
                    this.useCoupon();
                }
                if (
                    this.orderInfo.vipcardbalance &&
                    !this.isVipPay &&
                    !this.cardnos
                ) {
                    this.switchVipPay();
                }
            })
            .catch((error) => {
                console.log(error);
            });
    },
    watch: {
        isVipPay(newVal, val) {
            if (this.orderInfo.vipcardbalance && !this.cardnos) {
                this.checkVipCard();
            }
        },
        isWechatPay(newVal, val) {
            if (this.orderInfo.vipcardbalance && !this.cardnos) {
                this.checkVipCard();
            }
        },
        isAliPay(newVal, val) {
            if (this.orderInfo.vipcardbalance && !this.cardnos) {
                this.checkVipCard();
            }
        },
        isZeroPay(newVal, val) {
            console.log(val, newVal);
            if (newVal) {
                this.isWechatPay = false;
                this.isVipPay = false;
                this.isAliPay = false;
            }
        },
    },
    methods: {
        //  获取订单信息
        getOrderInfo() {
            return new Promise((resolve, reject) => {
                this.$post({
                    method: "member.order.get",
                    auth_code: this.getLocal("auth_code"),
                    tradeno: this.tradeno,
                    // txid: this.$global.txid
                }).then((res) => {
                    resolve(res);
                    this.orderInfo = res.data.order;
                    if (res.data.order.ordertype == "M") {
                        this.movieInfo = JSON.parse(res.data.order.description);
                    }
                    this.getRemainingTime();
                    //  优惠券不够抵扣订单金额时自动选中银联支付
                    if (
                        this.selectedCouponArr.length &&
                        res.data.order.amount &&
                        !this.isUnionPay &&
                        !this.isWechatPay
                    ) {
                        this.isAliPay = true;
                        this.isZeroPay = false;
                    } else if (
                        this.selectedCouponArr.length &&
                        res.data.order.amount
                    ) {
                        this.isZeroPay = false;
                    } else if (
                        this.selectedCouponArr.length &&
                        !res.data.order.amount
                    ) {
                        this.isZeroPay = true;
                    }
                }).catch((err) => {
                    reject(err)
                });
            });
        },
        //  获取订单支付剩余时间
        getRemainingTime() {
            this.$post({
                method: "member.order.remaining",
                auth_code: this.getLocal("auth_code"),
                tradeno: this.tradeno,
            }).then((res) => {
                if (res.success) {
                    this.remainingTime = res.data.remaining;
                    this.countDown();
                }
            });
        },
        //  倒计时
        countDown() {
            this.interval = null;
            this.interval = setInterval(() => {
                if (this.remainingTime < 1) {
                    clearInterval(this.interval);
                    this.interval = null;
                    this.$router.replace("/");
                }
                this.remainingTime--;
            }, 1000);
            this.$once("hook:beforeDestroy", () => {
                clearInterval(this.interval);
                this.interval = null;
            });
        },
        getCouponInfo() {
            return new Promise((resolve, reject) => {
                this.$post({
                    method: "member.coupon.available.list",
                    auth_code: this.getLocal("auth_code"),
                    tradeno: this.tradeno,
                }).then((res) => {
                    resolve(res);
                    if (res.success) {
                        this.couponList = res.data.couponlist;
                        // this.useCoupon();
                    }
                }).catch((err) => {
                    reject(err)
                });
            });
        },
        toggleCoupon() {
            if (!this.couponList.length) {
                Toast({
                    message: "无可用优惠券",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                return;
            }
            if (this.isVipPay) {
                Toast({
                    message: "优惠券与贵宾卡不可同享！",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                return;
            }
            this.$router.push({
                path: "selectCoupon",
                query: { tradeno: this.tradeno, ticketNum: this.ticketNum },
            });
            // console.log(this.cardnos);
            // let couponArr = [];
            // for (let i of this.couponList) {
            //     if (i.is_selected) {
            //         couponArr.push(i.cardno);
            //     }
            // }
            // this.selectedCouponArr = couponArr;
            // this.cardnos = this.selectedCouponArr.join(",");

            // if (!this.cardnos && this.showCoupons) {
            //     this.useCoupon();
            // } else if (this.showCoupons) {
            //     this.useCoupon();
            //     this.showCoupons = !this.showCoupons;
            // } else {
            //     this.showCoupons = !this.showCoupons;
            // }
        },
        //  选择优惠券
        selectCoupon(index) {
            let couponArr = [];
            for (let i of this.couponList) {
                if (i.is_selected) {
                    couponArr.push(i.cardno);
                }
            }
            this.selectedCouponArr = couponArr;
            if (this.isVipPay) {
                Toast({
                    message: "优惠不可与贵宾卡同享",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                return;
            }
            if (
                this.selectedCouponArr.length == this.ticketNum &&
                !this.couponList[index].is_selected
            ) {
                Toast({
                    message: "使用卡券的数量不能超过座位数",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                return;
            }
            this.$set(
                this.couponList[index],
                "is_selected",
                this.couponList[index].is_selected ? false : true
            );
        },
        useCoupon() {
            let couponArr = [];
            for (let i of this.couponList) {
                if (i.is_selected) {
                    couponArr.push(i.cardno);
                }
            }
            this.selectedCouponArr = couponArr;
            this.cardnos = this.selectedCouponArr.join(",");
            this.$post({
                method: "member.order.coupon.modify",
                tradeno: this.tradeno,
                auth_code: this.getLocal("auth_code"),
                cardnos: this.cardnos,
            }).then((res) => {
                if (res.success) {
                    clearInterval(this.interval);
                    this.interval = null;
                    this.getOrderInfo();
                    this.showCoupons = false;
                } else {
                    Toast({
                        message: res.error.desp,
                        position: "middle",
                        duration: 2000,
                        className: "toastBox",
                    });
                }
            });
            // this.showCoupons = false;
        },
        //  切换贵宾卡支付
        switchVipPay() {
            if (this.cardnos) {
                Toast({
                    message: "优惠不可与贵宾卡同享",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                return;
            }
            if (!this.orderInfo.vipcardbalance) {
                Toast({
                    message: "暂无可用余额",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                return;
            }
            this.isVipPay = !this.isVipPay;
            console.log(
                this.isVipPay,
                this.orderInfo.vipcardbalance / 100,
                this.orderInfo.originalamount
            );
            if (
                this.isVipPay &&
                this.orderInfo.vipcardbalance / 100 <
                    this.orderInfo.originalamount
            ) {
                if (this.isAliPay) {
                    this.isWechatPay = false;
                } else {
                    this.isWechatPay = true;
                    this.isAliPay = false;
                }
            } else if (
                this.isVipPay &&
                this.orderInfo.vipcardbalance / 100 >=
                    this.orderInfo.originalamount
            ) {
                this.isWechatPay = false;
                this.isAliPay = false;
            } else if (!this.isVipPay) {
                if (this.isAliPay) {
                    this.isWechatPay = false;
                } else {
                    this.isWechatPay = true;
                    this.isAliPay = false;
                }
            }

            // if (
            //     this.orderInfo.vipcardbalance / 100 < this.orderInfo.amount &&
            //     !this.isVipPay &&
            //     !this.isAliPay
            // ) {
            //     this.isVipPay = !this.isVipPay;
            //     this.isAliPay = true;
            //     this.isWechatPay = false;
            // } else if (
            //     this.orderInfo.vipcardbalance / 100 < this.orderInfo.amount &&
            //     !this.isVipPay &&
            //     this.isUnionPay
            // ) {
            //     this.isVipPay = !this.isVipPay;
            // } else if (
            //     this.orderInfo.vipcardbalance / 100 >= this.orderInfo.amount &&
            //     !this.isVipPay
            // ) {
            //     this.isVipPay = !this.isVipPay;
            //     this.isUnionPay = false;
            //     this.isAliPay = false;
            // } else {
            //     this.isVipPay = !this.isVipPay;
            // }
        },
        //  检查是否使用贵宾卡
        checkVipCard() {
            this.$post({
                method: "member.order.coupon.vipcard.modify",
                usestatus: this.isVipPay ? "Y" : "N",
                tradeno: !this.cardnos ? this.tradeno : "",
                auth_code: this.getLocal("auth_code"),
            }).then((res) => {
                if (res.success) {
                    clearInterval(this.interval);
                    this.interval = null;
                    this.getOrderInfo();
                }
            });
        },
        //  切换银联支付
        switchUnionPay() {
            // if (
            //     this.orderInfo.vipcardbalance / 100 < this.orderInfo.amount &&
            //     this.isUnionPay &&
            //     !this.selectedCouponArr.length
            // ) {
            //     this.isUnionPay = !this.isUnionPay;
            //     this.isVipPay = false;
            // } else if (
            //     this.orderInfo.vipcardbalance / 100 < this.orderInfo.amount &&
            //     this.isVipPay &&
            //     !this.isUnionPay
            // ) {
            //     this.isUnionPay = !this.isUnionPay;
            //     this.isAliPay = false;
            // } else if (
            //     this.orderInfo.vipcardbalance / 100 >= this.orderInfo.amount &&
            //     !this.isUnionPay &&
            //     !this.selectedCouponArr.length
            // ) {
            //     this.isUnionPay = !this.isUnionPay;
            //     this.isVipPay = false;
            // } else if (
            //     this.selectedCouponArr.length &&
            //     this.orderInfo.amount &&
            //     !this.isUnionPay
            // ) {
            //     this.isUnionPay = !this.isUnionPay;
            //     this.isAliPay = false;
            // } else if (
            //     this.selectedCouponArr.length &&
            //     this.orderInfo.amount &&
            //     this.isUnionPay
            // ) {
            //     this.isUnionPay = !this.isUnionPay;
            //     this.isAliPay = true;
            // } else if (this.isAliPay) {
            //     this.switchAliPay();
            //     this.isUnionPay = !this.isUnionPay;
            // } else {
            //     this.isUnionPay = !this.isUnionPay;
            // }
            // this.isWechatPay = false;
        },
        //  切换支付宝支付
        switchAliPay() {
            if (this.isZeroPay) {
                Toast({
                    message: "已使用优惠券",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                return;
            }
            this.isAliPay = !this.isAliPay;
            if (this.isAliPay) {
                this.isWechatPay = false;
                if (
                    this.orderInfo.vipcardbalance / 100 >=
                    this.orderInfo.originalamount
                ) {
                    this.isVipPay = false;
                }
            }
            if (
                !this.isAliPay &&
                this.orderInfo.vipcardbalance / 100 <
                    this.orderInfo.originalamount
            ) {
                this.isWechatPay = true;
            }
            if(!this.isAliPay && this.orderInfo.amount > 0 && this.cardnos){
                this.isWechatPay = true;
            }
        },
        switchWechatPay() {
            if (this.isZeroPay) {
                Toast({
                    message: "已使用优惠券",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                return;
            }
            this.isWechatPay = !this.isWechatPay;
            if (this.isWechatPay) {
                this.isAliPay = false;
                if (
                    this.orderInfo.vipcardbalance / 100 >=
                    this.orderInfo.originalamount
                ) {
                    this.isVipPay = false;
                }
            }
            if (
                !this.isWechatPay &&
                this.orderInfo.vipcardbalance / 100 <
                    this.orderInfo.originalamount
            ) {
                this.isAliPay = true;
            }
            if(!this.isWechatPay && this.orderInfo.amount > 0 && this.cardnos){
                this.isAliPay = true;
            }
        },
        prePay() {
            if (this.isVipPay || this.selectedCouponArr.length) {
                // this.togglePwdLayer();
                MessageBox.confirm("确认支付订单?")
                    .then((action) => {
                        if (action == "confirm") {
                            this.payment();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else if (this.isUnionPay && !this.isVipPay) {
                this.payment();
            } else if (this.isAliPay) {
                this.payment();
            } else if (this.isWechatPay && !this.isWeixin) {
                this.payment();
            } else if (this.isWechatPay && this.isWeixin && this.openid) {
                this.payment();
            } else if (this.isWechatPay && this.isWeixin && !this.openid) {
                let domain =
                    window.location.protocol + "//" + window.location.host; // 域名
                let isKfc = this.isKfc;
                const url = isKfc
                    ? encodeURI(
                          domain +
                              "/duwap/static/getCode/getCode.html?usertype=kfc"
                      )
                    : encodeURI(
                          domain +
                              "/duwap/static/getCode/getCode.html?usertype=movie"
                      );
                // const url = encodeURI(
                //     "https://wap.dumovie.com/duwap/static/getCode/getCode.html"
                // );
                window.location.href = url;
            } else {
                Toast({
                    message: "请选择支付方式",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
            }
        },
        payment() {
            Indicator.open("加载中...");

            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf("micromessenger") != -1 ? true : false;

            let paymethod = "";
            paymethod += this.isZeroPay ? "zeroPay" : "";
            paymethod += this.isVipPay ? "vipPay," : "";
            paymethod += this.isUnionPay ? "unionWapPay" : "";
            paymethod += this.isAliPay ? "aliWapPay" : "";
            // paymethod += this.isWechatPay ? "wxscanpay" : "";
            paymethod +=
                this.isWechatPay && !this.isWeixin
                    ? "wxwappay"
                    : this.isWechatPay && this.isWeixin
                    ? "wxjspay"
                    : "";
            // paymethod += this.isWechatPay ? "wxLittlePay" : "";
            console.log(paymethod);
            this.$post({
                method: "member.order.pay",
                paymethod: paymethod,
                paypass:
                    this.isVipPay || this.selectedCouponArr.length
                        ? this.payPwd
                        : "",
                auth_code: this.getLocal("auth_code"),
                tradeno: this.tradeno,
                openid: this.openid,
            })
                .then((res) => {
                    Indicator.close();
                    if (res.success) {
                        if (this.isUnionPay) {
                            let params = Object.assign({}, res.data);
                            console.log(params);
                            delete params.submitMethod;
                            this.formAction = res.data.payurl;
                            this.formData = params;
                            setTimeout("document.unionPayForm.submit()", 1000);
                        } else if (this.isAliPay) {
                            if (isWeixin) {
                                console.log("isAliPay, pay-Done");
                                // this.$router.push({
                                //     name: "preAliPay",
                                //     query: { tradeno: this.tradeno }
                                // });
                                window.location.href =
                                    "http://wx." +
                                    this.domainType +
                                    "/payfromwx/" +
                                    this.tradeno;
                            } else {
                                let params = Object.assign({}, res.data);
                                console.log(params);
                                this.formAction = res.data.payurl;
                                this.formData = params;
                                setTimeout(
                                    "document.aliPayForm.submit()",
                                    1000
                                );
                            }
                        } else if (this.isWechatPay && !this.isWeixin) {
                            this.showPayStatus = true;
                            document.location.href = res.data.payurl;
                        } else if (this.isWechatPay) {
                            console.log(res);
                            this.weixinPay(res.data);
                        } else if (this.isVipPay) {
                            console.log("isVipPay, pay-Done");
                            this.payDone();
                        } else if (this.isZeroPay) {
                            this.payDone();
                        }
                    } else {
                        Toast({
                            message: res.error.desp,
                            position: "middle",
                            duration: 2000,
                            className: "toastBox",
                        });
                    }
                })
                .catch((err) => {
                    Indicator.close();
                });
        },
        // 微信环境内使用微信支付
        weixinPay: function (data) {
            var vm = this;
            if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                    document.addEventListener(
                        "WeixinJSBridgeReady",
                        vm.onBridgeReady(data),
                        false
                    );
                } else if (document.attachEvent) {
                    document.attachEvent(
                        "WeixinJSBridgeReady",
                        vm.onBridgeReady(data)
                    );

                    document.attachEvent(
                        "onWeixinJSBridgeReady",
                        vm.onBridgeReady(data)
                    );
                }
            } else {
                vm.onBridgeReady(data);
            }
        },
        onBridgeReady: function (data) {
            var vm = this;
            WeixinJSBridge.invoke(
                "getBrandWCPayRequest",
                {
                    appId: data.appId, //公众号名称，由商户传入
                    timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
                    nonceStr: data.nonceStr, //随机串
                    package: data.package, //订单详情扩展字符串
                    signType: data.signType, //微信签名方式：
                    paySign: data.paySign, //微信签名
                },
                function (res) {
                    console.log(res);
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                        let auth_code = vm.getLocal("auth_code");
                        // window.location.href = "https://wx.dumovie.com/app/order/movie/list?auth_code=" + auth_code + '&app_source=h5';
                        window.location.href =
                            "https://wx." +
                            vm.domainType +
                            "/app/order/movie/list?auth_code=" +
                            auth_code +
                            "&app_source=h5";
                    } else {
                        Toast({
                            message: "支付失败！",
                            position: "middle",
                            duration: 2000,
                            className: "toastBox",
                        });
                    }
                }
            );
        },
        payDone() {
            let auth_code = this.getLocal("auth_code");
            window.location.href =
                "https://wx." +
                this.domainType +
                "/app/order/movie/list?auth_code=" +
                auth_code +
                "&app_source=h5";
        },
        payFail() {
            this.showPayStatus = false;
        },
        togglePwdLayer() {
            this.showPwdLayer = !this.showPwdLayer;
            this.payPwd = "";
        },
        toggleWechatLayer() {
            this.showWechatLayer = !this.showWechatLayer;
        },
        verifyPwd() {
            if (!this.payPwd) {
                Toast({
                    message: "请输入支付密码",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                return;
            } else if (this.payPwd.length < 6) {
                Toast({
                    message: "请输入正确的支付密码",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                return;
            }
            this.showPwdLayer = false;
            // console.log(this.isAliPay, this.isVipPay)
            // return
            this.payment();
        },
        forgetPwd() {
            this.$router.push({
                path: "/forgetPayPwd",
                query: { origin: "order" },
            });
        },
    },
};
</script>
<style lang="scss">
.confirmOrderWrap {
    .top {
        width: 100%;
        height: 276px;
        // position: fixed;
        // top: 0;
        background-image: url(../../../static/imgs/movie/top_bg.png);
        background-size: cover;
        background-position: center;
        color: #fff;
        .topContent {
            width: 100%;
            height: 176px;
            padding: 0 35px;
            box-sizing: border-box;
            h3 {
                font-size: 36px;
                margin-bottom: 30px;
            }
            p {
                font-size: 26px;
            }
            span {
                font-size: 36px;
            }
        }
    }
    .contentWrap {
        z-index: 3;
        margin-top: -100px;
        width: 100%;
        padding: 0 35px;
        box-sizing: border-box;
        .movieInfo {
            width: 100%;
            padding: 0 40px;
            box-sizing: border-box;
            height: 300px;
            background-color: #fff;
            border-radius: 15px;
            box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.08);
            .poster {
                width: 170px;
                height: 225px;
                margin-right: 38px;
            }
            .movieDetail {
                width: calc(100% - 208px);
                height: 225px;
                h3 {
                    font-size: 32px;
                    span {
                        font-size: 28px;
                        color: #e42f46;
                        min-width: 80px;
                        text-align: right;
                    }
                }
                span {
                    color: #999;
                    font-size: 24px;
                }
            }
        }
        .phoneBox {
            width: 100%;
            padding: 0 38px 0 48px;
            box-sizing: border-box;
            background: #fff;
            height: 120px;
            margin-top: 25px;
            border-radius: 15px;
            box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.08);
            .phoneIco {
                width: 74px;
                height: 74px;
                margin-right: 30px;
            }
            .txtWrap {
                height: 74px;
                strong {
                    font-size: 28px;
                }
                span {
                    font-size: 24px;
                    color: #999;
                }
            }
            .enterIco {
                width: 12px;
                height: 20px;
            }
        }
        .couponBox {
            width: 100%;
            padding: 0 38px 0 48px;
            box-sizing: border-box;
            background: #fff;
            height: 120px;
            margin-top: 25px;
            border-radius: 15px;
            box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.08);
            font-size: 28px;
            .couponIco {
                width: 74px;
                height: 74px;
                margin-right: 30px;
            }
            // .title {
            //     font-size: 28px;
            // }
            .txt {
                color: #999;
            }
            .enterIco {
                width: 12px;
                height: 20px;
                margin-left: 30px;
            }
        }
        .products {
            padding: 10px 30px;
            box-sizing: border-box;
            background: #fff;
            margin-top: 20px;
            border-radius: 15px;
            box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.08);
            .basicInfo {
                width: 100%;
                font-size: 28px;
                padding: 15px 0;
                border-bottom: 1px solid #dededf;
                img {
                    width: 200px;
                    height: 200px;
                }
                .info {
                    margin-left: 20px;
                    width: calc(100% - 220px);
                    h3 {
                        font-weight: bold;
                        line-height: 36px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 3;
                        -webkit-box-orient: vertical;
                    }
                    .price {
                        font-size: 36px;
                        color: #fe5200;
                    }
                }
            }
            .basicInfo:last-of-type {
                border-bottom: none;
            }
        }
        .payMethod {
            margin-top: 25px;
            background-color: #fff;
            border-radius: 15px;
            box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.08);
            .row {
                height: 120px;
                padding: 0 48px;
                box-sizing: border-box;
                font-size: 28px;
                border-bottom: 1px solid #c8c7cc; /* no */
                .rightIco {
                    width: 50px;
                    height: 50px;
                }
                .method {
                    .methodIco {
                        width: 74px;
                        height: 74px;
                        margin-right: 30px;
                    }
                    .unionPayIco {
                        width: 43px;
                        height: 29px;
                        margin-left: 10px;
                    }
                    em {
                        margin-left: 20px;
                        font-size: 24px;
                    }
                }
                .balance {
                    color: #9b9b9b;
                    .balanceNum {
                        margin-right: 20px;
                    }
                    .balanceDesp {
                        .txt {
                            font-size: 28px;
                            margin-right: 10px;
                        }
                        .greyTxt {
                            color: #9b9b9b;
                        }
                        .orangeTxt {
                            color: #ff5900;
                        }
                    }
                    .balanceDesp span {
                        margin-right: 20px;
                        height: 34px;
                        line-height: 34px;
                        font-size: 24px;
                    }
                    .checkBox {
                        width: 30px;
                        height: 30px;
                        // margin-left: 10px;
                        img {
                            width: 30px;
                            height: 30px;
                        }
                    }
                    .selected {
                        border: 4px solid #ff5204;
                    }
                    .notSelect {
                        border: 4px solid #e6e6e6;
                    }
                }
            }
            .row:last-of-type {
                border-bottom: none;
            }
        }
        .notice {
            width: 100%;
            background: #fff;
            margin-top: 25px;
            border-radius: 15px;
            box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.08);
            h3 {
                height: 100px;
                line-height: 100px;
                width: 100%;
                padding: 0 38px;
                box-sizing: border-box;
                font-size: 32px;
                border-bottom: 1px solid #e9e9e9;
            }
            p {
                width: 100%;
                padding: 32px 45px;
                box-sizing: border-box;
                color: #999;
                font-size: 24px;
                line-height: 36px;
                max-height: 100%;
            }
        }
    }
    .pay_status_layer {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 5;
        .status_dialog {
            width: 600px;
            background: #fff;
            border-radius: 10px;
            position: fixed;
            top: calc(50% - 300px);
            left: calc(50% - 300px);
            h3 {
                width: 100%;
                height: 120px;
                line-height: 120px;
                text-align: center;
                font-size: 32px;
            }
            p {
                width: 100%;
                height: 90px;
                line-height: 90px;
                text-align: center;
                border-top: 1px solid #dededf;
                font-size: 28px;
            }
            .done {
                color: #e42f46;
            }
            .fail {
                color: #999;
            }
        }
    }
    .btmBar {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 120px;
        background-color: #fff;
        padding: 0 35px 0 42px;
        color: #e42f46;
        // span {
        //     margin-left: 30px;
        //     font-size: 28px;
        // }
        button {
            width: 200px;
            height: 60px;
            color: #fff;
            background: #e42f46;
            font-size: 32px;
            border-radius: 8px;
            margin: 0;
        }
        .total {
            font-size: 52px;
            color: #e42f46;
            em {
                font-size: 42px;
            }
            span {
                font-size: 22px;
                width: 70px;
                height: 36px;
                line-height: 36px;
                line-height: 36px;
                background: #fbb342;
                color: #fff;
                margin-left: 20px;
                display: inline-block;
                text-align: center;
                border-radius: 5px;
            }
        }
        .discount {
            font-size: 24px;
            span {
                text-decoration: line-through;
            }
        }
    }
    .couponLayer {
        width: 100%;
        position: fixed;
        bottom: 0;
        background-color: #e6e6e6;
        z-index: 5;
        p {
            height: 120px;
            line-height: 120px;
            text-align: center;
            background-color: #fff;
            font-size: 28px;
        }
        .listWrap {
            height: 660px;
            overflow-y: scroll;
            .couponItem {
                width: 90%;
                height: 150px;
                margin: 20px auto 0 auto;
                padding: 0 30px;
                background-color: #fff;
                border-radius: 10px;
                position: relative;
                .selectedIco {
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 65px;
                    height: 65px;
                    background-color: #e42f46;
                    border-top-right-radius: 10px;
                    border-bottom-left-radius: 70px;
                    img {
                        width: 38px;
                        height: 38px;
                    }
                }
                .itemInfo {
                    height: 150px;
                    span {
                        font-size: 28px;
                        line-height: 40px;
                    }
                }
            }
        }
        button {
            // width: 100%;
            // height: 100px;
            width: 630px;
            height: 98px;
            margin: 40px 60px;
            color: #fff;
            background: #e42f46;
            font-size: 34px;
            border-radius: 49px;
        }
    }
    .couponLayer-enter {
        transform: translateY(958px);
    }
    .couponLayer-enter-active {
        transition: all 0.5s;
    }
    .shade {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        position: fixed;
        top: 0;
        z-index: 4;
    }
    .pwdLayer {
        width: 100%;
        position: fixed;
        top: 0;
        background: #f4f4f4;
        font-size: 28px;
        z-index: 5;
        p {
            width: 100%;
            height: 120px;
            line-height: 120px;
            border-bottom: 1px solid #c8c7cc;
            text-align: center;
            font-size: 28px;
        }
        input {
            height: 80px;
            width: 690px;
            margin: 30px 0;
            border-radius: 10px;
            text-align: center;
        }
        button {
            width: 214px;
            height: 78px;
            font-size: 28px;
            border-radius: 10px;
            margin: 40px 0;
        }
        .forgetPwd {
            width: 100%;
            text-align: right;
            padding: 0 30px;
            box-sizing: border-box;
        }
    }
    .wechatLayer {
        z-index: 5;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        right: 0;
        .wechatCode {
            width: 300px;
            height: 300px;
            position: absolute;
            top: 400px;
            right: calc(50% - 150px);
        }
        span {
            font-size: 30px;
            color: #fff;
            width: 300px;
            text-align: center;
            position: absolute;
            top: 750px;
            left: calc(50% - 150px);
        }
        .closeIco {
            width: 55px;
            height: 55px;
            position: absolute;
            top: 320px;
            right: 140px;
        }
    }

    .formBox {
        height: 1px;
        visibility: hidden;
        input {
            height: 1px;
        }
    }
}
.mint-msgbox {
    font-size: 28px !important;
    border-radius: 10px;
    .mint-msgbox-header {
        padding-top: 30px;
        .mint-msgbox-title {
            font-size: 30px !important;
        }
    }
    .mint-msgbox-content {
        padding: 30px;
    }
    .mint-msgbox-btns {
        height: 70px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/order/confirmOrder.vue